import $ from 'jquery';
import Breakpoints from './Breakpoints';
import Flickity from './Flickity';
import 'flickity-fade';

const config = {
  mobileSettings: {
    prevNextButtons: false,
  },
  tabletSettings: {
    prevNextButtons: false,
  },
};

export default class HomeNewsEvents {
  constructor(element) {
    this.element = element;

    // Exit if the sliderElement isn't found.
    if (!this.sliderElement) return;

    // Prevent initialization of a slider with less than 2 slides.
    if (this.shouldBuildSlider) {
      // Add listeners
      this.listen();
    }

    // Preprocess content
    this.preprocess();

    // Ready Component
    this.ready();
  }

  preprocess() {
    this.slides.forEach((slide) => {
      const $dates = $(slide).children().not('.dd-hover-dependencies').find('span.meta-item.event-date');
      if ($dates.length > 1) {
        $dates.not($dates.first()).remove();
        $dates.first().html('Multiple dates');
      }
    });
  }

  ready() {
    this.element.classList.add('ready');
  }

  build(settings) {
    return new Flickity(this.sliderElement, settings);
  }

  restore() {
    return new Promise((resolve) => {
      if (this.slider) {
        this.slider.destroy();
      }
      resolve();
    });
  }

  onMobileChange() {
    this.restore().then(this.slider = this.build(config.mobileSettings));
  }

  onTabletChange() {
    this.restore().then(this.slider = this.build(config.tabletSettings));
  }

  onDesktopChange() {
    this.restore();
  }

  listen() {
    // Listen for breakpoint changes
    Breakpoints.on('mobile', 'enter', this.onMobileChange.bind(this));
    Breakpoints.on('tablet', 'enter', this.onTabletChange.bind(this));
    Breakpoints.on('desktop larger', 'enter', this.onDesktopChange.bind(this));
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderElement() {
    return this.element.querySelector('.block-content');
  }

  get slides() {
    return this.sliderElement.children;
  }
}
